import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ActiveTelehealthCallService } from '@services';
import { initFlowbite } from 'flowbite';
import { filter, startWith } from 'rxjs';

const SIDE_PANEL_URL = /\/patient-list\/[^/]+\/[^/]+/;

@Component({
  selector: 'provider-portal-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  title = 'provider-portal';

  private readonly router = inject(Router);
  private readonly call = inject(ActiveTelehealthCallService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    initFlowbite();

    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        ),
        startWith(null),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        const path = this.router.url.split(/[?#]/)[0];
        this.call.setSideAllowed(SIDE_PANEL_URL.test(path));
      });
  }
}
